import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";

type RetryErrorMessageProps = {
    message: string;
}

export const RetryErrorMessage = (props: RetryErrorMessageProps) => {
    const { message } = props;
    const content = useSelector(getLanguageContent);

    return (
        <Alert variant={"warning"}>
            {message || content.form.messages.unableToVerify}
        </Alert>
    );
};